import SessionEventProto from "../session-event-proto";


export default class SessionEvent_DepartmentReset extends SessionEventProto {

    constructor(sessionEvent:any) {
        super(sessionEvent)
    }

    process() {

        gd.session.departments.reset(this.data)
    }
};
